import { useEffect, useState  } from "react";
import { VStack, Badge, Box, Button, Heading, Text, Flex, useToast, Spacer , SimpleGrid, Input, Modal, ModalOverlay, ModalCloseButton, ModalContent, ModalHeader, ModalBody, ModalFooter, Switch, Tooltip, useDisclosure,} from "@chakra-ui/react";
import { MdArrowBack, MdDelete, MdOutlinePlayArrow, } from "react-icons/md";
import { react_api } from "../../../config";
import { CASE_TYPE } from "../../../CaseTypeCostant";
import { HTTP_STATUS_CODES } from "../../../GrinsCostant";
import logout from "../../../services/authService";
import createAxiosInstance from "../../../interceptors/useAxiosInterceptors";
import Nova from "./Nova/Nova";

import { useTranslation } from "react-i18next";
import { useSession } from "../../../SessionContext";
import { useNavigate, useLocation } from "react-router-dom";
import SpinnerXL from "../../SpinnerXL";
import { useBreakpointValue } from "@chakra-ui/react";

const getBackgroundColorByVisibility = (visibility) => {
    if (visibility === "private") {
        return "green.400";
    } else if (visibility === "obtained") {
        return "orange.400";
    } else if (visibility === "public") {
        return "yellow.400";
    } else if (visibility === "general") {
        return "blue.400";
    } else {
        return "blue.500";
    }
};
const DatasetItem = ({ id, text, visibility, onSelect, isSelected }) => {
    let buttonColor = isSelected ? "gray.400" : getBackgroundColorByVisibility(visibility);
    return (
        <Button
            h="20px"
            bg={buttonColor}
            borderWidth={1}
            borderColor={"black"}
            onClick={()=> onSelect(text)}
            isDisabled={isSelected} 
            maxW="100%" 
            overflow="hidden" 
            textOverflow="ellipsis" 
            whiteSpace="nowrap"
            display="inline-block"
        >
            {text}
        </Button>
    );
};

const CategoryBox = ({ id, name, color, items, onSelect, selectedDataset, t, searchTerm, onSearchChange, }) => {
    const filteredItems = items.filter((item) =>
        item.table_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <Box key={id} mt={4} p={3} borderRadius="md" borderWidth={2} borderColor={`${color}.500`}>
            <Heading fontSize="md" color={`${color}.600`} mb={2}>
                {name}
            </Heading>
            <Input
                bg={"white"}
                placeholder={`${t("nova.datasetBox.searchDataset")}${name}`}
                value={searchTerm}
                onChange={(e) => onSearchChange(id, e.target.value)}
                mb={2}
            />
            {filteredItems.length > 0 ? (
                filteredItems.map(({ table_id, table_name, visibility }) => (
                    <DatasetItem
                        key={table_id}
                        id={{ id: table_name, type: "dataset" }}
                        text={table_name}
                        visibility={visibility}
                        onSelect={onSelect}
                        isSelected={selectedDataset === table_name}
                    />
                ))
            ) : (
                <Text color="gray.500">{t("nova.datasetBox.noDatasetsAvailable")}</Text>
            )}  
        </Box>
    );
};

function NovaADP() {
    const location = useLocation();
    const titleService = location.state?.title;
    const { t } = useTranslation();
    const [catalog, setCatalog] = useState([]);
    const [selectedDataset, setSelectedDataset] = useState(null);
    const [datasetDescription, setDatasetDescription] = useState(null);
    const [columns, setColumns] = useState([]);
    const toast = useToast();
    const navigate = useNavigate();
    const { updateSessionData, clearSessionData } = useSession();
    const axiosInstance = createAxiosInstance(async (axiosInstance) => {
        logout(t, clearSessionData, navigate, toast, axiosInstance);
    });
    const [selectAll, setSelectAll] = useState(false);
    const [childData, setChildData] = useState(null);
    const [selectedTableId, setSelectedTableId] = useState(null);
    const [resultApp, setResultApp] = useState(false);
    const selectedColumns = Array.isArray(columns) ? columns.filter((col) => col.selected).map((col) => col.columnName) : [];
    const showOperations = selectedColumns.length >= 2;
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                const richiesta = {
                    BearerToken: sessionStorage.getItem("token"),
                    username: sessionStorage.getItem("username"),
                    caseType: CASE_TYPE.CATALOG_ALL,
                };
                const options = {
                    headers: {
                    "Content-Type": "application/json",
                    }
                };
                const urlFetch = `${react_api}/DragAndDrop/getDatasetsADP`;
                const response = await axiosInstance.post(urlFetch, richiesta, options);
                const result = response.data;
                const tablesInfo = result?.tables_info;

                if ( result == null || (Object.keys(result).length === 0)) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('messageBE.momentaryCommunicationError'), 
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;  
                }

                if (!Array.isArray(tablesInfo) || tablesInfo.length === 0) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('toastMsg.momentaryCommunicationError'),
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;
                }
                if (result.status !== HTTP_STATUS_CODES.OK) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t(`messageBE.${result.message}`),
                        position: "top",
                        status: 'error',
                        duration: 4000,
                        isClosable: true
                    });
                }
                if (result.status === HTTP_STATUS_CODES.OK) {
                    setCatalog(result.tables_info);
                }
            } catch (error) {
                toast({
                    title: t('toastMsg.callError'),
                    description: String(error),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
            }
        };
        fetchCatalog();
    }, [toast]);



    const getMetadataDataset = async (tableId) => {
        try {
            setSpinnerLoading(true)
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
            const urlFetch = `${react_api}/getMetadataADP/${tableId}`;
            const response = await axiosInstance.get(urlFetch, options);

            if (response.status.toString() === HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                setDatasetDescription(response.data.description);
            } else {
                throw new Error(t('toastMsg.nova.dataRecoveryError'));
            }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                status: 'warning',
                duration: 4000,
                isClosable: true
            });
        }
    };
    
    const getTableColMasked = async (id) => {
        try {
            const body = {
                BearerToken: sessionStorage.getItem("token"),
                username: sessionStorage.getItem("username"),
                tableId: id,
            };
            const urlFetch = `${react_api}/privateService/getTableColMasked`;
            const response = await axiosInstance.post(urlFetch, body, {
                headers: { 'Content-Type': 'application/json' },
            });
            return response.data;
        } catch (error) {
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                status: 'warning',
                duration: 4000,
                isClosable: true,
            });
            return null;
        }
    };

    const viewDataset = async (tableId, TBL_NAME) => {
        try {
            setSpinnerLoading(true);
            const body = {
            BearerToken: sessionStorage.getItem("token"),
            username: sessionStorage.getItem("username"),
            tableName: TBL_NAME,
            };
            const options = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': sessionStorage.getItem("token")
                },
            }
            const urlFetch = `${react_api}/getTableADP`;
            const response = await axiosInstance.post(urlFetch, body, options);
            const data = response?.data;

            if ( data == null || (Object.keys(data).length === 0)) {
                toast({
                    title: t('toastMsg.error'),
                    description: t('messageBE.momentaryCommunicationError'), 
                    status: 'warning',
                    duration: 4000,
                    isClosable: true,
                    position: 'top'
                });
                return;  
            }
            if (data.status === HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                return response.data.previewTable; 
            } else {
                throw new Error(t('toastMsg.nova.dataRecoveryError'));
            }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                status: 'warning',
                duration: 4000,
                isClosable: true
            });
        }
    };

    const [searchTerms, setSearchTerms] = useState({});
    
    const handleSearchChange = (categoryId, value) => {
        setSearchTerms((prev) => ({ ...prev, [categoryId]: value }));
    };

    const categories = [
        { id: 1, name: "Catalog General", type: "catalogo_generale", color: "blue" },
        { id: 2, name: "Catalog Results", type: "catalogo_risultati", color: "green" },
        { id: 3, name: "Catalog Processing", type: "catalogo_elaborazioni", color: "orange" },
        { id: 4, name: "Catalog Staging", type: "catalogo_staging", color: "purple" },
    ];

    const handleStart = async () => {
        const preview = await viewDataset(selectedTableId, selectedDataset);
        const payload = {
            username: sessionStorage.getItem("username"),
            BearerToken: sessionStorage.getItem("token"),
            request: {
                dataset_name: selectedDataset,
                dataset_description: datasetDescription ? datasetDescription : "",
                fields: columns.filter(col => col.selected).map(col => {
                    const samples = preview.slice(0, 3).map(row => row[col.columnName]);
                    return {
                        column: col.columnName,
                        properties: {
                            dtype: col.type,
                            description: col.description,
                            samples : samples,                 
                        }
                    };
                })
            }
        };
        setChildData(payload);
        setResultApp(true);
    };

    const handleDatasetSelect = async  (dataset) => {
        clearAllData();
        setSelectedDataset(dataset);
        const selectedTable = catalog.find(item => item.table_name === dataset);
        setSelectedTableId(selectedTable.table_id);
        if (!selectedTable) return;

        try {
            const colRes = await getTableColMasked(selectedTable.table_id);
            if (!colRes || colRes.status !== "200") {
                toast({
                    title: t('toastMsg.callError'),
                    description: t('toastMsg.nova.columnsRetrievalError'),
                    status: 'warning',
                    duration: 4000,
                    isClosable: true
                });
                return;
            }

            const excluded = ["metadata_vd", "metadata_vtd", "metadata_ud"];
            const filtered = colRes.columns
                .filter(col => col.mask_label === "0" && !excluded.includes(col.column_name))
                .sort((a, b) => a.index - b.index);

            const baseCols = filtered.map(col => ({
                columnName: col.column_name,
                type: col.type,
                description: col.fielddescription,
                samples: [],
                selected: false,
            }));
            setColumns(baseCols);
        } catch (err) {
            toast({ title: t('toastMsg.nova.columnsCallError'), description: String(err), status: "warning" });
        }

        getMetadataDataset(selectedTable.table_id);
    };

    const toggleColumn = (columnName) => {
        setColumns(prevCols => {
            const updated = prevCols.map(col =>
                col.columnName === columnName
                ? { ...col, selected: !col.selected }
                : col
            );
            const allSelected = updated.every(col => col.selected);
            setSelectAll(allSelected);
            return updated;
        });
    };

    const toggleAllColumns = () => {
        setColumns(prevCols => {
            const newAll = !selectAll;
            setSelectAll(newAll);
            return prevCols.map(col => ({ ...col, selected: newAll }));
        });
    };

    const isStartDisabled = () => {
        if (!selectedDataset) return true;
        if (columns.filter((c) => c.selected).length < 2) return true;
        return false;
    };
    
    const clearAllData = () => {
        setDatasetDescription(null);
        setColumns([]);
        setSelectedDataset(null);
        setSelectAll(false);
        setSearchTerms({});
    };
    
    const clearResult = () =>{
        setResultApp(false);
        setChildData(null);
    };
    
    const handleConfirm = () => {
        clearAllData();
        clearResult();
        onClose();
    };

    const responsiveHeight = useBreakpointValue({
        base: "auto",
        md: "80vh",
        lg: "calc(100vh - 70px)" 
    });

    return (
        <Box position="relative" height="100%" width="100%" p={2} bg="#f6f3ec">
            {spinnerLoading && (
                <SpinnerXL />
            )}
            <Flex mb={2} align="center" gap={2} pr={3}>
                <Heading color={"rgba(11,78,90,255)"}>{titleService}</Heading>
                <Spacer />
                {!resultApp && (
                    <>
                        <Button size="sm" variant="outline" colorScheme="red" _hover={{bg: "red.500", color: "white",}} onClick={() => onOpen()}>{t('nova.btnClearData')} <MdDelete size={18} /></Button>
                        <Button size="sm" variant="outline" _hover={{bg: "green.500", color: "white",}} colorScheme="green" onClick={handleStart} isDisabled={isStartDisabled()}>{t('nova.btnStart')} <MdOutlinePlayArrow size={18} /></Button>
                    </>
                )}
                {resultApp && (
                    <Button  p={3} gap={2} size="sm" variant="outline" _hover={{bg: "teal.500", color: "white",}} colorScheme="teal" onClick={()=>clearResult()}><MdArrowBack size={18} />{t('nova.btnBack')}</Button>
                )}
            </Flex>
            <Flex height={responsiveHeight} gap={2} align="flex-start" overflowX="auto">
                {!resultApp && (
                    <>
                        <Box borderColor="rgba(23, 141, 161, 1)" backgroundColor="rgba(230, 232, 232, 1)" borderRadius={5} borderWidth={2} overflowY="auto" height="100%" width="15%" p={4} >
                            <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('nova.summaryBox.summary')}:</Text>
                            {selectedDataset && (
                                <>
                                    <Text fontWeight="semibold">Dataset :</Text>
                                    <Tooltip label={selectedDataset} hasArrow>
                                        <Badge colorScheme="teal" fontWeight="normal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                            {selectedDataset}
                                        </Badge>
                                    </Tooltip>
                                    <Text mt={2} fontWeight="semibold">{t('nova.summaryBox.datasetDescription')}:</Text>
                                    {datasetDescription && (
                                        <Tooltip label={datasetDescription.length > 50 ? datasetDescription : null} hasArrow placement="bottom-start" openDelay={300} maxW="1000px" whiteSpace="normal" >
                                            <Text as="span" cursor="pointer">
                                                {datasetDescription.length > 50 ? (
                                                    <>
                                                        {datasetDescription.substring(0, 50)}
                                                        <Text as="span" color="green.500"> ► </Text>
                                                    </>
                                                ) : (
                                                    datasetDescription
                                                )}
                                            </Text>
                                        </Tooltip>
                                    )}
                                </>
                            )}

                            {selectedColumns.length > 0 && (
                                <>
                                    <Text mt={2} fontWeight="semibold">{t('nova.summaryBox.sumColumns')} :</Text>
                                    <VStack spacing={1} wrap="wrap" align="start">
                                        {selectedColumns.map((col, index) => (
                                            <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                                <Tooltip key={index} label={col} hasArrow>
                                                    <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                    {col}
                                                    </Badge>
                                                </Tooltip>
                                            </Flex>
                                        ))}
                                    </VStack>
                                </>
                            )}
                        </Box>
                        <Box borderWidth={2} overflowY="scroll" borderColor="rgba(23, 141, 161, 1)" borderRadius={5} height="100%" width="40%" p={3}>
                            <Box justifyContent="space-between">
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Dataset</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('nova.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="green" variant="solid">Private</Badge>
                                    <Badge ml={2} colorScheme="yellow" variant="solid">Public</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Obtained</Badge>
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                </Box>
                            </Box>
    
                            <Box justifyContent="space-between" mt={"1%"}>
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Catalog</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('nova.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                    <Badge ml={2} colorScheme="green" variant="solid">Results</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Processing</Badge>
                                    <Badge ml={2} colorScheme="purple" variant="solid">Staging</Badge>
                                </Box>
                            </Box>
                            {categories.map(({ id, name, color }) => {
                                const filteredCatalog = catalog.filter(item => Number(item.cataloguetype_id) === id);

                                return (
                                    <CategoryBox
                                        key={id}
                                        id={id}
                                        name={name}
                                        color={color}
                                        items={filteredCatalog}
                                        onSelect={handleDatasetSelect}
                                        selectedDataset={selectedDataset}
                                        searchTerm={searchTerms[id] || ""}
                                        onSearchChange={handleSearchChange}
                                        t={t}
                                    />
                                );
                            })}
                        </Box>
                        {selectedDataset && (
                            <Box borderColor="rgba(23, 141, 161, 1)" borderRadius={5} borderWidth={2} overflowY="auto" height="100%" width="45%" p={4}>
                                <Flex align="center" mb={2}>
                                    <Text mr={2}>{t('nova.columnsBox.selectAll')} :</Text>
                                    <Switch colorScheme="teal" isChecked={selectAll} onChange={toggleAllColumns} />
                                </Flex>
                                <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('nova.columnsBox.columns')} :</Text>
                                <SimpleGrid columns={[1, 2, 3]} spacing={4} mt={2}>
                                    {columns.map((col, index) => (
                                        <Flex key={col.columnName} align="center" textOverflow="ellipsis" maxW="100%" mt={2}>
                                            <Tooltip key={col.columnName} label={col.columnName} hasArrow>
                                                <Badge key={col.columnName} color="black" border="1px solid #0888BE" bg="transparent" borderRadius="md" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {col.columnName}
                                                </Badge>
                                            </Tooltip>
                                            <Switch colorScheme="teal" ml={2} isChecked={col.selected} onChange={() => toggleColumn(col.columnName)} />
                                        </Flex>
                                    ))}
                                </SimpleGrid>
                            </Box>
                        )}
                    </>
                )}
                {resultApp && (
                    <Box height={responsiveHeight} width="100%">
                        <Nova directData={childData} />
                    </Box>
                )}
            </Flex>
            <Modal isOpen={isOpen} onClose={() => { onClose(); }} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('nova.modal.confirmationCancellation')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {t('nova.modal.infoConfirmationCancellation')}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleConfirm}>
                        {t('nova.modal.yes')}
                        </Button>
                        <Button colorScheme="red" onClick={() => { onClose(); }}>
                        No
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
}

export default NovaADP;
